import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container container-dark-theme" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Navbar from '@/components/Navbar/Navbar.vue';
import Footer from '@/components/Footer.vue';

import { useThemeStore } from '@/stores/theme';
import { useNavMenuStore } from '@/stores/navMenu';

import { addEventOnOpeningNavBySliding } from '@/functions/addEventOnOpeningNavBySliding';
import { updateLangAttribute } from '@/functions/updateLangAttribute';
// import { updateBackgroundColorOnScrollbar } from '@/functions/updateBackgroundColorOnScrollbar';

import { onMounted } from '@vue/runtime-core';
import { watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

// Hide navbar and footer on GeoMapper page
const showNavbar = computed(() => route.name !== 'GeoMapper');
const showFooter = computed(() => route.name !== 'GeoMapper');

onMounted(() => {
    addEventOnOpeningNavBySliding();
    updateLangAttribute();
    // updateBackgroundColorOnScrollbar();
});

const themeStore = useThemeStore();

const navMenuStore = useNavMenuStore();
watch(
    () => navMenuStore.opened,
    (opened) => {
        document.body.setAttribute('overflow', opened ? 'hidden' : 'visible');
    }
);


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (showNavbar.value)
      ? (_openBlock(), _createBlock(Navbar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view),
    (showFooter.value)
      ? (_openBlock(), _createBlock(Footer, { key: 1 }))
      : _createCommentVNode("", true)
  ]))
}
}

})